import { useEffect } from 'react';
import { buildSeoGraph } from '../../utils/seoGraph';

const SITE_URL = 'https://nmhelper.in/';
const OG_IMAGE = 'https://nmhelper.in/thumbnail.jpg';
const JSONLD_ID = 'nmhelper-dynamic-jsonld';

function upsertMeta({ selector, attr, attrValue, content }) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
  return el;
}

export function SeoHead({ labels, useMalayalam, faqs = [] }) {
  useEffect(() => {
    const lang = useMalayalam ? 'ml' : 'en';
    const ogLocale = useMalayalam ? 'ml_IN' : 'en_IN';

    document.documentElement.setAttribute('lang', lang);

    const titleStr = `${labels.landingTitle} | NMhelper`;
    document.title = titleStr;

    const desc =
      labels.landingMetaDescription ||
      labels.landingSubtitle ||
      labels.landingFooterTagline ||
      '';

    upsertMeta({
      selector: 'meta[name="description"]',
      attr: 'name',
      attrValue: 'description',
      content: desc,
    });
    upsertMeta({
      selector: 'meta[property="og:title"]',
      attr: 'property',
      attrValue: 'og:title',
      content: titleStr,
    });
    upsertMeta({
      selector: 'meta[property="og:description"]',
      attr: 'property',
      attrValue: 'og:description',
      content: desc,
    });
    upsertMeta({
      selector: 'meta[property="og:url"]',
      attr: 'property',
      attrValue: 'og:url',
      content: SITE_URL,
    });
    upsertMeta({
      selector: 'meta[property="og:image"]',
      attr: 'property',
      attrValue: 'og:image',
      content: OG_IMAGE,
    });
    upsertMeta({
      selector: 'meta[property="og:locale"]',
      attr: 'property',
      attrValue: 'og:locale',
      content: ogLocale,
    });
    upsertMeta({
      selector: 'meta[name="twitter:title"]',
      attr: 'name',
      attrValue: 'twitter:title',
      content: titleStr,
    });
    upsertMeta({
      selector: 'meta[name="twitter:description"]',
      attr: 'name',
      attrValue: 'twitter:description',
      content: desc,
    });
    upsertMeta({
      selector: 'meta[name="twitter:image"]',
      attr: 'name',
      attrValue: 'twitter:image',
      content: OG_IMAGE,
    });

    const payload = buildSeoGraph({ labels, lang, faqs, pageUrl: SITE_URL });

    let script = document.getElementById(JSONLD_ID);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = JSONLD_ID;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(payload);

    return () => {
      const s = document.getElementById(JSONLD_ID);
      if (s && s.parentNode) s.parentNode.removeChild(s);
    };
  }, [labels, useMalayalam, faqs]);

  return null;
}

export default SeoHead;
